import { GETOFFICIALTOPICSURL } from './urls';
import { localStorageSave, localStorageLoad } from './localStorage';
import { conn } from './conn';

const officialTopicsStorKey = 'official_topics';

const getOfficialTopics = async (checkUpdate = false) => {

  let ret;

  const savedTopic = localStorageLoad(officialTopicsStorKey);
  if (checkUpdate || !savedTopic || !savedTopic.topics) {
    let query = '';
    if (savedTopic && savedTopic.lastUpdate) {
      query = '?updated=' + savedTopic.lastUpdate;
    }
    // 'Up to date!' // ?updated=
    const { data } = await conn().get(GETOFFICIALTOPICSURL + query);
    if (data && data.msg === 'Up to date!') {
      ret = savedTopic.topics;
    } else if(data && data.topics) {
      data.topics=data.topics.reduce((accum,curr)=>{
        if(curr.category.toLowerCase()==='other') {
          return accum;
        }

        curr.topics=curr.topics.filter(elem=>elem.name.toLowerCase()!=='other');
        return [...accum,curr]
      },[]);
      localStorageSave({
        [officialTopicsStorKey]: data
      })
      ret = data.topics;
    }
  } else {
    ret = savedTopic.topics;
  }
  /* {lastUpdate, topics} */




  return ret;
}



export { getOfficialTopics, officialTopicsStorKey }